import { AdjustmentStatuses } from 'constants/adjustmentStatuses';
import { BankOperationStatuses } from 'constants/bankOperationStatuses';
import { InviteStatuses } from 'constants/inviteStatuses';
import { OrderStatuses } from 'constants/orderStatuses';
import { UserActionTypes } from 'constants/userActionTypes';

export const statusColors = {
  orderStatus: {
    [OrderStatuses.Created]: '#42A5F5',
    [OrderStatuses.Pending]: '#FF9800',
    [OrderStatuses.Failure]: '#EF5350',
    [OrderStatuses.Success]: '#4CAF50',
    [OrderStatuses.Refund]: '#BDBDBC',
    [OrderStatuses.Expired]: '#EF5351',
    [OrderStatuses.Chargeback]: '#BDBDBA',
    [OrderStatuses.Prepared]: '#42A5F6',
    [OrderStatuses.Cancelled]: '#BDBDBD',
    [OrderStatuses.WaitingConfirmation]: '#ED6C02',
  },

  orderStatusBackground: {
    [OrderStatuses.Created]: '#E6F3FA',
    [OrderStatuses.Success]: '#EAF2EA',
    [OrderStatuses.Failure]: '#FBEAEA',
    [OrderStatuses.Refund]: '#F3F4F6',
    [OrderStatuses.WaitingConfirmation]: '#FDF0E6',
  },

  adjustmentStatus: {
    [AdjustmentStatuses.Created]: '#1976D2',
    [AdjustmentStatuses.InProgress]: '#ED6C02',
    [AdjustmentStatuses.Rejected]: '#D32F2F',
    [AdjustmentStatuses.Completed]: '#2E7D32',
  },

  bankOperationStatus: {
    [BankOperationStatuses.Created]: '#42A5F5',
    [BankOperationStatuses.Reviewing]: '#FF9800',
    [BankOperationStatuses.Canceled]: '#EF5350',
    [BankOperationStatuses.Approved]: '#4CAF50',
  },

  inviteStatus: {
    [InviteStatuses.Wait]: '#FF9800',
    [InviteStatuses.Expired]: '#EF5351',
    [InviteStatuses.Sent]: '#42A5F6',
    [InviteStatuses.Accepted]: '#4CAF50',
  },

  userActionType: {
    [UserActionTypes.PUT]: '#42A5F6',
    [UserActionTypes.POST]: '#4CAF50',
    [UserActionTypes.DELETE]: '#EF5350',
  },
};

export type OrderStatusColorKey = keyof typeof statusColors.orderStatus;
export type OrderStatusBackgroundColorKey = keyof typeof statusColors.orderStatusBackground;
export type AdjustmentStatusColorKey = keyof typeof statusColors.adjustmentStatus;
export type BankOperationStatusColorKey = keyof typeof statusColors.bankOperationStatus;
export type InviteStatusColorKey = keyof typeof statusColors.inviteStatus;
export type UserActionTypeColorKey = keyof typeof statusColors.userActionType;
